import Vue from 'vue'

import 'normalize.css'
import './assets/style/index.css'

import directives from './directives'

Vue.directive('loading', {
  // 当被绑定的元素插入到 DOM 中时……
  inserted: function (el, binding, vnode) {
    const loadingClassName = 'is-loading'
    const value = binding.value
    const target = el
    if (value) {
      target.classList.add(loadingClassName)
    }
    // 监听变化并更新元素
    vnode.context.$watch(binding.expression, (newVal) => {
      if (target) {
        newVal ? target.setAttribute('disabled', 'disabled') 
               : target.removeAttribute('disabled')
        newVal ? target.classList.add(loadingClassName) 
               : target.classList.remove(loadingClassName)
      }
    })
  },
})

import LoadingJs from './components/loading'
import ToastJs from './components/toast'
import DialogJs from './components/dialog'

import Button from './components/button/button.vue'
import Switch from './components/switch/switch.vue'
import Icon from './components/icon/icon.vue'
import Badge from './components/badge/badge.vue'
import Dialog from './components/dialog/dialog.vue'
import Empty from './components/empty/empty.vue'
import Text from './components/text/text.vue'
import Loading from './components/loading/loading.vue'
import Search from './components/search/search.vue'
import Field from './components/field/field.vue'
import Drawer from './components/drawer/drawer.vue'
import NavBar from './components/navBar/navBar.vue'
import ActionBar from './components/actionBar/actionBar.vue'
import ActionBarIcon from './components/actionBar/actionBarIcon.vue'
import Tab from './components/tab/tab.vue'
import BottomTip from './components/bottomTip/bottomTip.vue'

const components = [
  Button, 
  Switch, 
  Icon, 
  Badge,
  Dialog,
  Empty, 
  Text, 
  Loading,
  Search,
  Field,
  Drawer,
  NavBar,
  ActionBar,
  ActionBarIcon,
  Tab,
  BottomTip,
  
  LoadingJs,
  ToastJs,
  DialogJs,
]

const install = (Vue) => {
  components.forEach(c => {
    if (c.install) {
      Vue.use(c)
    } else {
      Vue.component(c.name, c)
    }
  })
}

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

export default {
  install
}